import React, { useContext, useState } from "react";
import { Form, Stack, Input, Button, Container, Text } from "basis";

import { logger } from "../../core";
import AuthContext from "../../core/AuthContext";

import verifyGatewayCredentials from "./utils/verifyGatewayCredentials";

const validateApiKey = (val, { isEmpty }) => {
  if (isEmpty(val)) {
    return "Required";
  }

  const API_KEY_REGEX = /^[a-zA-Z0-9-]{4,30}$/gi;

  if (!Boolean(API_KEY_REGEX.test(val))) {
    return "Please enter API key id";
  }

  return null;
};

const validateApiSecret = (val, { isEmpty }) => {
  if (isEmpty(val)) {
    return "Required";
  }

  const SECRET_REGEX = /[(a-zA-Z0-9_-]{10,80}/gm;

  if (!Boolean(SECRET_REGEX.test(val))) {
    return "Please enter API secret";
  }

  return null;
};

const FORM_INITIAL_VALUES = {
  apiKey: "",
  apiSecret: "",
  isTestMode: false,
};

const GatewaySettings = ({
  shop,
  gatewayName,
  initialValues = FORM_INITIAL_VALUES,
  onSuccess = () => {},
}) => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  const token = useContext(AuthContext);

  const handleSubmit = async (formData) => {
    setErrorMessage("");

    const { errors, values } = formData;

    if (Object.keys(errors).length > 0) {
      return;
    }

    setLoading(true);

    try {
      const response = await verifyGatewayCredentials(
        values,
        shop,
        gatewayName,
        token
      );

      if (!response?.appID) {
        setLoading(false);
        const message =
          "Failed to verify credentials. Try again with correct credentials.";
        logger.error(message);
        setErrorMessage(message);
        return;
      }

      onSuccess({ appID: response.appID });
    } catch (err) {
      setLoading(false);
      const message =
        "Failed to verify credentials. Try again with correct credentials.";
      logger.error(`${message} ${JSON.stringify(err)}`);
      setErrorMessage(message);
    }
  };

  return (
    <Container padding="6 8">
      <Form initialValues={initialValues} method="post" onSubmit={handleSubmit}>
        <Stack gap="4">
          <Input
            name="apiKey"
            color="white"
            label="API Key"
            placeholder="API Key"
            min={4}
            max={30}
            validate={validateApiKey}
          />

          <Input
            name="apiSecret"
            type="password"
            color="white"
            label="API Secret"
            placeholder="API Secret"
            min={10}
            max={80}
            validate={validateApiSecret}
          />
          <Text textStyle="body2" color="conditional.negative.text">
            {errorMessage}
          </Text>

          <Button loading={loading} type="submit">
            Verify credentials
          </Button>
        </Stack>
      </Form>
    </Container>
  );
};

export default GatewaySettings;
